import { KpkApiMediaDownloadLevel, KpkApiShareTokenExportDefinition } from '@keepeek/api-client';

function isDownloadLevelAllowed(element, downloadLevel) {
    switch (downloadLevel) {
        case KpkApiMediaDownloadLevel.None:
            return ((element === null || element === void 0 ? void 0 : element.downloadLevel) === KpkApiMediaDownloadLevel.None ||
                (element === null || element === void 0 ? void 0 : element.downloadLevel) === KpkApiMediaDownloadLevel.Bd ||
                (element === null || element === void 0 ? void 0 : element.downloadLevel) === KpkApiMediaDownloadLevel.HD);
        case KpkApiMediaDownloadLevel.Bd:
            return ((element === null || element === void 0 ? void 0 : element.downloadLevel) === KpkApiMediaDownloadLevel.Bd ||
                (element === null || element === void 0 ? void 0 : element.downloadLevel) === KpkApiMediaDownloadLevel.HD);
        case KpkApiMediaDownloadLevel.HD:
            return (element === null || element === void 0 ? void 0 : element.downloadLevel) === KpkApiMediaDownloadLevel.HD;
    }
    return false;
}
function sortDownloadLevel(a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === KpkApiShareTokenExportDefinition.None &&
        (b === KpkApiShareTokenExportDefinition.Bd || b === KpkApiShareTokenExportDefinition.HD)) {
        return -1;
    }
    else if (a === KpkApiShareTokenExportDefinition.Bd &&
        b === KpkApiShareTokenExportDefinition.HD) {
        return -1;
    }
    else if (a === KpkApiShareTokenExportDefinition.Bd &&
        b === KpkApiShareTokenExportDefinition.None) {
        return 1;
    }
    else if (a === KpkApiShareTokenExportDefinition.HD) {
        return 1;
    }
    else {
        return -1;
    }
}

export { isDownloadLevelAllowed, sortDownloadLevel };
//# sourceMappingURL=utils.js.map
